import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
    selector: 'app-modal-confirmation',
    templateUrl: './modal-confirmation.component.html',
    styleUrl: './modal-confirmation.component.scss',
    standalone: false
})
export class ModalConfirmationComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() icon: string | null;
  @Input() title: string;
  @Input() text: string;
  @Input() sameLineButtons: boolean;
  @Input() hideCancelButton?: boolean = false;
  @Input() width: string;
  @Input() centerText: boolean = false;
  @Input() htmlText: boolean = false;
  @Input() loading?: boolean = false;
  @Input() confirmText?: string;
  @Input() cancelText?: string;
  @Input() confirmStyle?: string = 'primary';
  @Input() cancelStyle?: string = 'secondary';
  @Input() extraInfoIcon?: string;
  @Input() extraInfoText?: string;
  @Input() extraInfoCheckbox?: string;
  @Output() action = new EventEmitter<any>();
  @Output() cancelAction = new EventEmitter<any>();

  public images = images;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json'
  };

  extraInfoChecked: boolean = false;

  constructor(public literalService: LiteralService, public utilsService: UtilsService) {}

  onCheckboxChange(event: any) {
    this.extraInfoChecked = event.target.checked;
  }

  onConfirm() {
    this.action.emit(this.extraInfoCheckbox ? this.extraInfoChecked : true);
  }

  onCancel() {
    this.cancelAction.emit();
    this.modal.hide();
  }
}
